/**
 * 
 * @copyright     (c) 2024-2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/LabelButton/index.js
 * Created:       Mon May 06 2024
 * Modified By:   Greg Olive
 * Last Modified: Tue Nov 04 2025
 */

import React from "react";

import { LoadingSpinner } from "@proxy/_components";

export default function LabelButton({
  label,
  image,
  onChange,
  loading
}) {
  return (
    <label className="gc__label_button" htmlFor="gc__video_upload">
      <div className={"gc__label_button_image_container"}>
        {
          loading ?
            <LoadingSpinner /> :
            <img className={"gc__icon"} src={image} alt="" />
        }
      </div>
      <div className="gc__label_button_text">
        {label}
      </div>
      <input
        id="gc__video_upload"
        type="file"
        accept="video/*"
        capture="user"
        onChange={onChange}
      />
    </label>
  );
};
